//sidebar images
import AdjustmentIcon from "../assets/Icons/adjustments.svg";
import GlobeIcon from "../assets/Icons/globe.svg";
import SettingIcon from "../assets/Icons/setting.svg";
import MenuIcon from "../assets/Icons/Menu.svg";
import AlertIcon from "../assets/Icons/alert.svg";

//menuItems icons
import OverViewIcon from "../assets/Icons/chartpie.svg";
import InBoxIcon from "../assets/Icons/inboxin.svg";
import ClipBoardIcon from "../assets/Icons/clipboardlist.svg";
import CollectionIcon from "../assets/Icons/collection.svg";
import SupportIcon from "../assets/Icons/support.svg";
import ChevronUp from "../assets/Icons/chevron-up.svg";
import ChevronDown from "../assets/Icons/chevron-down.svg";
//submenu icons
import PagesIcon from "../assets/Icons/documentreport.svg";
import ShoppingBagIcon from "../assets/Icons/shoppingbag.svg";
import LockIcon from "../assets/Icons/lock-closed.svg";

//content images
import FacebookIcon from "../assets/SocialIcons/facebook.svg";
import TwitterIcon from "../assets/SocialIcons/twitter.svg";
import GithubIcon from "../assets/SocialIcons/github.svg";
import DribbleIcon from "../assets/SocialIcons/dribble.svg";
import Wsp from '../assets/SocialIcons/Wsp.svg';
import InstagramIcon from '../assets/SocialIcons/instagram.svg';

//header icons
import Logo from "../assets/Icons/Logo.svg";
import BellIcon from "../assets/Icons/Bell.svg";
import HeaderAvatar from "../assets/Avatars/HeaderAvtar.svg";

//customers lists icons
import Neil from "../assets/Avatars/Neil.svg";
import UIKit from "../assets/Avatars/Bonnie.svg";
import Karen from "../assets/Avatars/Karen.svg";
import Lana from "../assets/Avatars/Lana.svg";
import Micheal from "../assets/Avatars/Micheal.svg";
import Thomas from "../assets/Avatars/Thomas.svg";

export const CustomImg = {
  AdjustmentIcon,
  GlobeIcon,
  SettingIcon,
  MenuIcon,
  AlertIcon,
  OverViewIcon,
  InBoxIcon,
  ClipBoardIcon,
  CollectionIcon,
  SupportIcon,
  ChevronUp,
  ChevronDown,
  PagesIcon,
  ShoppingBagIcon,
  LockIcon,
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  GithubIcon,
  DribbleIcon,
  Logo,
  BellIcon,
  HeaderAvatar,
  Neil,
  UIKit,
  Karen,
  Lana,
  Micheal,
  Thomas,
  Wsp
};
